import { useCallback, useRef } from 'react';

/**
 * Manages an AbortController ref with automatic cleanup of previous controllers.
 * Calling `createAbortController` aborts any in-flight controller before
 * returning a fresh one, and `abort` tears down the current controller.
 */
export const useAbortController = () => {
  const abortControllerRef = useRef<AbortController | null>(null);

  const createAbortController = useCallback(() => {
    abortControllerRef.current?.abort();
    const abortController = new AbortController();
    abortControllerRef.current = abortController;
    return abortController;
  }, []);

  const abort = useCallback(() => {
    abortControllerRef.current?.abort();
    abortControllerRef.current = null;
  }, []);

  return { createAbortController, abort };
};
